import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';

export default function SalaryConverter() {
  const [scrolled, setScrolled] = useState(false);
  const [salary, setSalary] = useState('75000');
  const [usState, setUsState] = useState('california');
  const [irishCounty, setIrishCounty] = useState('dublin');

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // All 50 US States with 2024 state income tax rates
  const usStates = [
    { id: 'alabama', name: 'Alabama', taxRate: 0.05, col: 0.88 },
    { id: 'alaska', name: 'Alaska', taxRate: 0, col: 1.27 },
    { id: 'arizona', name: 'Arizona', taxRate: 0.025, col: 0.97 },
    { id: 'arkansas', name: 'Arkansas', taxRate: 0.049, col: 0.86 },
    { id: 'california', name: 'California', taxRate: 0.093, col: 1.38 },
    { id: 'colorado', name: 'Colorado', taxRate: 0.044, col: 1.05 },
    { id: 'connecticut', name: 'Connecticut', taxRate: 0.0699, col: 1.08 },
    { id: 'delaware', name: 'Delaware', taxRate: 0.066, col: 1.01 },
    { id: 'florida', name: 'Florida', taxRate: 0, col: 1.02 },
    { id: 'georgia', name: 'Georgia', taxRate: 0.0575, col: 0.89 },
    { id: 'hawaii', name: 'Hawaii', taxRate: 0.11, col: 1.84 },
    { id: 'idaho', name: 'Idaho', taxRate: 0.058, col: 0.92 },
    { id: 'illinois', name: 'Illinois', taxRate: 0.0495, col: 0.93 },
    { id: 'indiana', name: 'Indiana', taxRate: 0.0323, col: 0.90 },
    { id: 'iowa', name: 'Iowa', taxRate: 0.06, col: 0.89 },
    { id: 'kansas', name: 'Kansas', taxRate: 0.057, col: 0.87 },
    { id: 'kentucky', name: 'Kentucky', taxRate: 0.045, col: 0.91 },
    { id: 'louisiana', name: 'Louisiana', taxRate: 0.0425, col: 0.93 },
    { id: 'maine', name: 'Maine', taxRate: 0.0715, col: 0.96 },
    { id: 'maryland', name: 'Maryland', taxRate: 0.0575, col: 1.19 },
    { id: 'massachusetts', name: 'Massachusetts', taxRate: 0.05, col: 1.31 },
    { id: 'michigan', name: 'Michigan', taxRate: 0.0425, col: 0.89 },
    { id: 'minnesota', name: 'Minnesota', taxRate: 0.0985, col: 0.97 },
    { id: 'mississippi', name: 'Mississippi', taxRate: 0.05, col: 0.84 },
    { id: 'missouri', name: 'Missouri', taxRate: 0.054, col: 0.87 },
    { id: 'montana', name: 'Montana', taxRate: 0.0675, col: 0.94 },
    { id: 'nebraska', name: 'Nebraska', taxRate: 0.0684, col: 0.91 },
    { id: 'nevada', name: 'Nevada', taxRate: 0, col: 1.04 },
    { id: 'newhampshire', name: 'New Hampshire', taxRate: 0, col: 1.09 },
    { id: 'newjersey', name: 'New Jersey', taxRate: 0.1075, col: 1.13 },
    { id: 'newmexico', name: 'New Mexico', taxRate: 0.059, col: 0.91 },
    { id: 'newyork', name: 'New York', taxRate: 0.109, col: 1.39 },
    { id: 'northcarolina', name: 'North Carolina', taxRate: 0.0475, col: 0.94 },
    { id: 'northdakota', name: 'North Dakota', taxRate: 0.029, col: 0.98 },
    { id: 'ohio', name: 'Ohio', taxRate: 0.0399, col: 0.93 },
    { id: 'oklahoma', name: 'Oklahoma', taxRate: 0.05, col: 0.87 },
    { id: 'oregon', name: 'Oregon', taxRate: 0.099, col: 1.13 },
    { id: 'pennsylvania', name: 'Pennsylvania', taxRate: 0.0307, col: 0.96 },
    { id: 'rhodeisland', name: 'Rhode Island', taxRate: 0.0599, col: 1.09 },
    { id: 'southcarolina', name: 'South Carolina', taxRate: 0.07, col: 0.88 },
    { id: 'southdakota', name: 'South Dakota', taxRate: 0, col: 1.03 },
    { id: 'tennessee', name: 'Tennessee', taxRate: 0, col: 0.89 },
    { id: 'texas', name: 'Texas', taxRate: 0, col: 0.91 },
    { id: 'utah', name: 'Utah', taxRate: 0.0485, col: 0.98 },
    { id: 'vermont', name: 'Vermont', taxRate: 0.0875, col: 1.09 },
    { id: 'virginia', name: 'Virginia', taxRate: 0.0575, col: 1.03 },
    { id: 'washington', name: 'Washington', taxRate: 0, col: 1.15 },
    { id: 'westvirginia', name: 'West Virginia', taxRate: 0.065, col: 0.87 },
    { id: 'wisconsin', name: 'Wisconsin', taxRate: 0.0765, col: 0.96 },
    { id: 'wyoming', name: 'Wyoming', taxRate: 0, col: 0.91 }
  ];

  // All 26 Irish Counties with cost of living adjustments
  const irishCounties = [
    { id: 'dublin', name: 'Dublin', col: 1.00 },
    { id: 'cork', name: 'Cork', col: 0.85 },
    { id: 'galway', name: 'Galway', col: 0.88 },
    { id: 'limerick', name: 'Limerick', col: 0.78 },
    { id: 'waterford', name: 'Waterford', col: 0.72 },
    { id: 'kilkenny', name: 'Kilkenny', col: 0.70 },
    { id: 'wicklow', name: 'Wicklow', col: 0.82 },
    { id: 'meath', name: 'Meath', col: 0.80 },
    { id: 'kildare', name: 'Kildare', col: 0.82 },
    { id: 'clare', name: 'Clare', col: 0.68 },
    { id: 'mayo', name: 'Mayo', col: 0.65 },
    { id: 'donegal', name: 'Donegal', col: 0.62 },
    { id: 'louth', name: 'Louth', col: 0.75 },
    { id: 'westmeath', name: 'Westmeath', col: 0.68 },
    { id: 'offaly', name: 'Offaly', col: 0.66 },
    { id: 'laois', name: 'Laois', col: 0.68 },
    { id: 'carlow', name: 'Carlow', col: 0.70 },
    { id: 'wexford', name: 'Wexford', col: 0.72 },
    { id: 'tipperary', name: 'Tipperary', col: 0.66 },
    { id: 'kerry', name: 'Kerry', col: 0.72 },
    { id: 'roscommon', name: 'Roscommon', col: 0.62 },
    { id: 'sligo', name: 'Sligo', col: 0.66 },
    { id: 'leitrim', name: 'Leitrim', col: 0.60 },
    { id: 'cavan', name: 'Cavan', col: 0.65 },
    { id: 'monaghan', name: 'Monaghan', col: 0.65 },
    { id: 'longford', name: 'Longford', col: 0.62 }
  ];

  const selectedState = usStates.find(s => s.id === usState) || usStates[4];
  const selectedCounty = irishCounties.find(c => c.id === irishCounty) || irishCounties[0];

  const salaryNum = parseFloat(salary) || 0;

  // US Federal Tax Calculation (2024 brackets for single filer)
  const calculateUSFederalTax = (income: number): number => {
    const brackets = [
      { limit: 11600, rate: 0.10 },
      { limit: 47150, rate: 0.12 },
      { limit: 100525, rate: 0.22 },
      { limit: 191950, rate: 0.24 },
      { limit: 243725, rate: 0.32 },
      { limit: 609350, rate: 0.35 },
      { limit: Infinity, rate: 0.37 }
    ];

    let tax = 0;
    let previousLimit = 0;

    for (const bracket of brackets) {
      if (income > previousLimit) {
        const taxableInBracket = Math.min(income, bracket.limit) - previousLimit;
        tax += taxableInBracket * bracket.rate;
        previousLimit = bracket.limit;
      } else {
        break;
      }
    }

    return tax;
  };

  // Irish PAYE Calculation (2024 rates for single person)
  const calculateIrishPAYE = (income: number): number => {
    const standardRateBand = 42000; // Single person standard rate band
    const standardRate = 0.20;
    const higherRate = 0.40;

    if (income <= standardRateBand) {
      return income * standardRate;
    } else {
      return (standardRateBand * standardRate) + ((income - standardRateBand) * higherRate);
    }
  };

  // Irish USC Calculation (2024 rates)
  const calculateIrishUSC = (income: number): number => {
    const brackets = [
      { limit: 12012, rate: 0.005 },
      { limit: 25760, rate: 0.02 },
      { limit: 70044, rate: 0.045 },
      { limit: Infinity, rate: 0.08 }
    ];

    let usc = 0;
    let previousLimit = 0;

    for (const bracket of brackets) {
      if (income > previousLimit) {
        const taxableInBracket = Math.min(income, bracket.limit) - previousLimit;
        usc += taxableInBracket * bracket.rate;
        previousLimit = bracket.limit;
      } else {
        break;
      }
    }

    return usc;
  };

  // US Tax Calculations
  const federalTax = calculateUSFederalTax(salaryNum);
  const stateTax = salaryNum * selectedState.taxRate;
  
  // FICA: Social Security (6.2% up to $168,600) + Medicare (1.45% on all income)
  const socialSecurity = Math.min(salaryNum, 168600) * 0.062;
  const medicare = salaryNum * 0.0145;
  const additionalMedicare = salaryNum > 200000 ? (salaryNum - 200000) * 0.009 : 0;
  const fica = socialSecurity + medicare + additionalMedicare;
  
  const usTotalTax = federalTax + stateTax + fica;
  const usNetSalary = salaryNum - usTotalTax;
  const usAdjustedSalary = usNetSalary / selectedState.col;

  // Irish Tax Calculations
  const irishPaye = calculateIrishPAYE(salaryNum);
  const irishUsc = calculateIrishUSC(salaryNum);
  const irishPrsi = salaryNum * 0.04; // 4% PRSI on all income
  const irishTotalTax = irishPaye + irishUsc + irishPrsi;
  const irishNetSalary = salaryNum - irishTotalTax;
  const irishAdjustedSalary = irishNetSalary / selectedCounty.col;

  const difference = irishAdjustedSalary - usAdjustedSalary;
  const percentDiff = ((difference / usAdjustedSalary) * 100).toFixed(1);

  // Calculate effective tax rates
  const usEffectiveRate = ((usTotalTax / salaryNum) * 100).toFixed(1);
  const irishEffectiveRate = ((irishTotalTax / salaryNum) * 100).toFixed(1);

  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Navbar scrolled={scrolled} />
      
      {/* Header */}
      <section className="pt-32 pb-16 px-6 bg-[#0A381F] text-white">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">US to Ireland Salary Converter</h1>
          <p className="text-xl text-white/80 max-w-3xl">Compare your real purchasing power using accurate progressive tax brackets for both countries. See what your US salary is really worth in Ireland.</p>
        </div>
      </section>

      <div className="py-16 px-6">
        <div className="max-w-7xl mx-auto">
          {/* Input Section */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 mb-12">
            <h2 className="text-2xl font-bold text-[#0A381F] mb-8">Enter Your Details</h2>
            <div className="grid md:grid-cols-3 gap-6">
              <div>
                <label className="block text-sm font-semibold text-[#0A381F] mb-2">Annual Salary (USD)</label>
                <div className="relative">
                  <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 font-semibold">$</span>
                  <input
                    type="number"
                    value={salary}
                    onChange={(e) => setSalary(e.target.value)}
                    className="w-full pl-8 pr-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#D4AF37] focus:outline-none text-lg font-semibold cursor-pointer"
                    placeholder="75000"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-semibold text-[#0A381F] mb-2">US State</label>
                <select
                  value={usState}
                  onChange={(e) => setUsState(e.target.value)}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#D4AF37] focus:outline-none text-lg font-semibold cursor-pointer"
                >
                  {usStates.map(state => (
                    <option key={state.id} value={state.id}>{state.name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-semibold text-[#0A381F] mb-2">Irish County</label>
                <select
                  value={irishCounty}
                  onChange={(e) => setIrishCounty(e.target.value)}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#D4AF37] focus:outline-none text-lg font-semibold cursor-pointer"
                >
                  {irishCounties.map(county => (
                    <option key={county.id} value={county.id}>{county.name}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Comparison Results */}
          <div className="grid lg:grid-cols-2 gap-8 mb-12">
            {/* US Results */}
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 flex items-center justify-center bg-[#0A381F] text-white rounded-full">
                  <i className="ri-flag-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-[#0A381F]">{selectedState.name}</h3>
                  <p className="text-sm text-gray-600">United States</p>
                </div>
              </div>

              <div className="space-y-4 mb-6">
                <div className="flex justify-between items-center pb-3 border-b border-gray-100">
                  <span className="text-gray-700">Gross Salary</span>
                  <span className="font-bold text-[#0A381F]">${salaryNum.toLocaleString()}</span>
                </div>
                <div className="flex justify-between items-center pb-3 border-b border-gray-100">
                  <span className="text-gray-700">Federal Tax (Progressive)</span>
                  <span className="font-semibold text-red-600">-${federalTax.toLocaleString(undefined, {maximumFractionDigits: 0})}</span>
                </div>
                <div className="flex justify-between items-center pb-3 border-b border-gray-100">
                  <span className="text-gray-700">State Tax ({(selectedState.taxRate * 100).toFixed(1)}%)</span>
                  <span className="font-semibold text-red-600">-${stateTax.toLocaleString(undefined, {maximumFractionDigits: 0})}</span>
                </div>
                <div className="flex justify-between items-center pb-3 border-b border-gray-100">
                  <span className="text-gray-700">FICA (SS + Medicare)</span>
                  <span className="font-semibold text-red-600">-${fica.toLocaleString(undefined, {maximumFractionDigits: 0})}</span>
                </div>
                <div className="flex justify-between items-center pb-3 border-b-2 border-gray-200">
                  <span className="font-bold text-gray-700">Net Salary</span>
                  <span className="font-bold text-[#0A381F]">${usNetSalary.toLocaleString(undefined, {maximumFractionDigits: 0})}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">Effective Tax Rate</span>
                  <span className="text-sm font-semibold text-red-600">{usEffectiveRate}%</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">Cost of Living Adjustment</span>
                  <span className="text-sm font-semibold text-gray-700">{(selectedState.col * 100).toFixed(0)}%</span>
                </div>
              </div>

              <div className="bg-[#0A381F] text-white rounded-xl p-6">
                <p className="text-sm text-white/70 mb-2">Real Purchasing Power</p>
                <p className="text-3xl font-bold">${usAdjustedSalary.toLocaleString(undefined, {maximumFractionDigits: 0})}</p>
              </div>
            </div>

            {/* Ireland Results */}
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 flex items-center justify-center bg-[#169B62] text-white rounded-full">
                  <i className="ri-flag-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-[#0A381F]">{selectedCounty.name}</h3>
                  <p className="text-sm text-gray-600">Ireland</p>
                </div>
              </div>

              <div className="space-y-4 mb-6">
                <div className="flex justify-between items-center pb-3 border-b border-gray-100">
                  <span className="text-gray-700">Gross Salary</span>
                  <span className="font-bold text-[#0A381F]">€{salaryNum.toLocaleString()}</span>
                </div>
                <div className="flex justify-between items-center pb-3 border-b border-gray-100">
                  <span className="text-gray-700">PAYE (20%/40% Progressive)</span>
                  <span className="font-semibold text-red-600">-€{irishPaye.toLocaleString(undefined, {maximumFractionDigits: 0})}</span>
                </div>
                <div className="flex justify-between items-center pb-3 border-b border-gray-100">
                  <span className="text-gray-700">USC (Progressive 0.5%-8%)</span>
                  <span className="font-semibold text-red-600">-€{irishUsc.toLocaleString(undefined, {maximumFractionDigits: 0})}</span>
                </div>
                <div className="flex justify-between items-center pb-3 border-b border-gray-100">
                  <span className="text-gray-700">PRSI (4%)</span>
                  <span className="font-semibold text-red-600">-€{irishPrsi.toLocaleString(undefined, {maximumFractionDigits: 0})}</span>
                </div>
                <div className="flex justify-between items-center pb-3 border-b-2 border-gray-200">
                  <span className="font-bold text-gray-700">Net Salary</span>
                  <span className="font-bold text-[#0A381F]">€{irishNetSalary.toLocaleString(undefined, {maximumFractionDigits: 0})}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">Effective Tax Rate</span>
                  <span className="text-sm font-semibold text-red-600">{irishEffectiveRate}%</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">Cost of Living Adjustment</span>
                  <span className="text-sm font-semibold text-gray-700">{(selectedCounty.col * 100).toFixed(0)}%</span>
                </div>
              </div>

              <div className="bg-[#169B62] text-white rounded-xl p-6">
                <p className="text-sm text-white/70 mb-2">Real Purchasing Power</p>
                <p className="text-3xl font-bold">€{irishAdjustedSalary.toLocaleString(undefined, {maximumFractionDigits: 0})}</p>
              </div>
            </div>
          </div>

          {/* Difference Summary */}
          <div className={`rounded-2xl p-8 shadow-lg border-2 mb-12 ${difference >= 0 ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200'}`}>
            <div className="text-center">
              <h3 className="text-2xl font-bold text-[#0A381F] mb-4">Real Income Difference</h3>
              <div className="flex items-center justify-center gap-4 mb-4">
                <div className={`w-16 h-16 flex items-center justify-center rounded-full ${difference >= 0 ? 'bg-green-600' : 'bg-red-600'} text-white`}>
                  <i className={`text-3xl ${difference >= 0 ? 'ri-arrow-up-line' : 'ri-arrow-down-line'}`}></i>
                </div>
                <div>
                  <p className={`text-4xl font-bold ${difference >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                    {difference >= 0 ? '+' : ''}€{Math.abs(difference).toLocaleString(undefined, {maximumFractionDigits: 0})}
                  </p>
                  <p className={`text-xl font-semibold ${difference >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                    ({percentDiff}%)
                  </p>
                </div>
              </div>
              <p className="text-gray-700 text-lg">
                {difference >= 0 
                  ? `Moving to ${selectedCounty.name} would give you ${percentDiff}% more purchasing power than ${selectedState.name}`
                  : `Moving to ${selectedCounty.name} would give you ${Math.abs(parseFloat(percentDiff))}% less purchasing power than ${selectedState.name}`
                }
              </p>
            </div>
          </div>

          {/* Tax System Explanation */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 mb-12">
            <h3 className="text-2xl font-bold text-[#0A381F] mb-6">Understanding the Tax Systems</h3>
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h4 className="font-bold text-[#0A381F] mb-4 flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#0A381F] text-white rounded-full">
                    <i className="ri-flag-line text-sm"></i>
                  </div>
                  US Tax System (2024)
                </h4>
                <div className="space-y-3 text-sm text-gray-700">
                  <div>
                    <p className="font-semibold mb-1">Federal Income Tax (Progressive):</p>
                    <ul className="list-disc list-inside space-y-1 ml-2">
                      <li>10% up to $11,600</li>
                      <li>12% on $11,601-$47,150</li>
                      <li>22% on $47,151-$100,525</li>
                      <li>24% on $100,526-$191,950</li>
                      <li>32% on $191,951-$243,725</li>
                      <li>35% on $243,726-$609,350</li>
                      <li>37% above $609,350</li>
                    </ul>
                  </div>
                  <div>
                    <p className="font-semibold mb-1">FICA:</p>
                    <ul className="list-disc list-inside space-y-1 ml-2">
                      <li>Social Security: 6.2% (up to $168,600)</li>
                      <li>Medicare: 1.45% (all income)</li>
                      <li>Additional Medicare: 0.9% (above $200,000)</li>
                    </ul>
                  </div>
                  <div>
                    <p className="font-semibold mb-1">State Tax:</p>
                    <p className="ml-2">Varies by state (0% to 10.9%)</p>
                  </div>
                </div>
              </div>

              <div>
                <h4 className="font-bold text-[#0A381F] mb-4 flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#169B62] text-white rounded-full">
                    <i className="ri-flag-line text-sm"></i>
                  </div>
                  Irish Tax System (2024)
                </h4>
                <div className="space-y-3 text-sm text-gray-700">
                  <div>
                    <p className="font-semibold mb-1">PAYE (Income Tax - Progressive):</p>
                    <ul className="list-disc list-inside space-y-1 ml-2">
                      <li>20% on first €42,000 (single person)</li>
                      <li>40% on income above €42,000</li>
                    </ul>
                  </div>
                  <div>
                    <p className="font-semibold mb-1">USC (Universal Social Charge - Progressive):</p>
                    <ul className="list-disc list-inside space-y-1 ml-2">
                      <li>0.5% on first €12,012</li>
                      <li>2% on €12,013-€25,760</li>
                      <li>4.5% on €25,761-€70,044</li>
                      <li>8% on income above €70,044</li>
                    </ul>
                  </div>
                  <div>
                    <p className="font-semibold mb-1">PRSI (Social Insurance):</p>
                    <p className="ml-2">4% on all income</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Key Insights */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 mb-12">
            <h3 className="text-2xl font-bold text-[#0A381F] mb-6">Key Insights</h3>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="flex gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#D4AF37] text-white rounded-full flex-shrink-0">
                  <i className="ri-percent-line text-2xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-[#0A381F] mb-2">Progressive Tax Impact</h4>
                  <p className="text-gray-700 text-sm">
                    Both countries use progressive tax systems. Higher earners pay significantly more in taxes. Your effective rate: US {usEffectiveRate}% vs Ireland {irishEffectiveRate}%
                  </p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#D4AF37] text-white rounded-full flex-shrink-0">
                  <i className="ri-heart-pulse-line text-2xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-[#0A381F] mb-2">Healthcare Included</h4>
                  <p className="text-gray-700 text-sm">Ireland includes universal healthcare in taxes. US healthcare costs (insurance, deductibles, copays) are additional expenses not shown here.</p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#D4AF37] text-white rounded-full flex-shrink-0">
                  <i className="ri-time-line text-2xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-[#0A381F] mb-2">Work-Life Balance</h4>
                  <p className="text-gray-700 text-sm">Ireland mandates 20 days paid vacation minimum. Many US jobs offer 10-15 days. This quality of life benefit isn't reflected in salary.</p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#D4AF37] text-white rounded-full flex-shrink-0">
                  <i className="ri-calculator-line text-2xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-[#0A381F] mb-2">Accurate Calculations</h4>
                  <p className="text-gray-700 text-sm">
                    This calculator uses 2024 progressive tax brackets for both countries, providing accurate results across all income levels.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-br from-[#0A381F] to-[#0D4A28] text-white rounded-2xl p-8 mb-12">
            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold mb-4">Need Help with Your Relocation?</h3>
              <p className="text-white/90 max-w-2xl mx-auto">
                Connect with experts who can help you navigate taxes, find jobs, and make your move to Ireland successful.
              </p>
            </div>
            <div className="grid md:grid-cols-3 gap-6">
              <a
                href="https://www.greenbacktaxservices.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="bg-white/10 backdrop-blur-sm p-6 rounded-xl hover:bg-white/20 transition-all cursor-pointer border border-white/20"
              >
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-file-text-line text-white text-2xl"></i>
                </div>
                <h4 className="font-bold text-white mb-2">Tax Services</h4>
                <p className="text-white/80 text-sm mb-3">Expert US expat tax filing</p>
                <span className="text-[#D4AF37] font-semibold text-sm">Free Consultation →</span>
              </a>

              <Link
                to="/directory?category=Legal"
                className="bg-white/10 backdrop-blur-sm p-6 rounded-xl hover:bg-white/20 transition-all cursor-pointer border border-white/20"
              >
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-briefcase-line text-white text-2xl"></i>
                </div>
                <h4 className="font-bold text-white mb-2">Find Jobs</h4>
                <p className="text-white/80 text-sm mb-3">Browse Irish job opportunities</p>
                <span className="text-[#D4AF37] font-semibold text-sm">Search Jobs →</span>
              </Link>

              <Link
                to="/community"
                className="bg-white/10 backdrop-blur-sm p-6 rounded-xl hover:bg-white/20 transition-all cursor-pointer border border-white/20"
              >
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-group-line text-white text-2xl"></i>
                </div>
                <h4 className="font-bold text-white mb-2">Join Community</h4>
                <p className="text-white/80 text-sm mb-3">Connect with other expats</p>
                <span className="text-[#D4AF37] font-semibold text-sm">Get Started →</span>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
